import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { DynFormsService } from '../../dyn-forms/logic/dyn-forms.service';
import { MessagesService } from '../../message/logic/message.service';
import { Message } from 'src/app/_model/message';

@Injectable({
  providedIn: 'root',
})
export class ReceivedMessageActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'message';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private messagesService: MessagesService
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    this.logger.log(
      this.constructor.name,
      'start ReceivedMessageActionHandler with params',
      params
    );
    const subject = params?.subject;
    const text = params?.message;
    const timestamp = params?.timestamp
    const senderId = params?.senderid
    const sender = params?.sender

    if (!timestamp || !text) {
      this.logger.error(
        this.constructor.name,
        'ReceivedMessageActionHandler requires subject and message parameters'
      );
      return;
    }
    const message = new Message(
      text, Date.now(), timestamp, senderId, sender, subject, undefined, false
    )
    this.messagesService.addMessage(message)
  }

  // Private Functions
}
